import { createStore, applyMiddleware, Store, compose } from "redux";
import thunk from "redux-thunk";
import { ApplicationState } from "./initialState";
import { rootReducer } from "./rootReducer";

export default function configureStore(initialState: ApplicationState): Store<ApplicationState> {
  const composeEnhancer: typeof compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(rootReducer, initialState, composeEnhancer(applyMiddleware(thunk)));
  return store;
}
